import type { DashboardConfig } from '../config';
import { clusterBase } from '../clusterBase';

export const brazilConfig: DashboardConfig = {
  path: '/carrefour/brazil',
  reportId: 'world-cup-engagement',
  label: 'Carrefour Brasil',
  // BR campaign is over and its dedicated backend is being retired. The
  // (frozen) payload + catalog row were copied to the EU reporting DB, so the
  // report is served from the EU cluster — same playbook as AH.
  apiBaseUrl: clusterBase('eu'),
  endsOn: '2026-07-20', // World Cup, 26 May → 20 Jul — archived from the day after
  frozen: true, // pipeline retired — the frozen payload must never be regenerated
  segmentsLocation: 'overview',
  hide: {
    topPrizes: true,
  },
};
